import { render, staticRenderFns } from "./finishProduct.vue?vue&type=template&id=51fb4f2a&scoped=true&"
import script from "./finishProduct.vue?vue&type=script&lang=js&"
export * from "./finishProduct.vue?vue&type=script&lang=js&"
import style0 from "./finishProduct.vue?vue&type=style&index=0&id=51fb4f2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fb4f2a",
  null
  
)

export default component.exports